import React, { Component } from 'react'
import { Redirect, Route, Switch, Router } from 'react-router-dom'
import { IconContext } from 'react-icons'

// redux
import { history } from '../redux/store'
import { connect } from 'react-redux'

// screens
import HomeScreen from './Home'
import OrganizationManagementScreen from './OrganizationManagement'
import RequireLoginComponent from '../components/LoginRequireComponent'
import LoginScreen from './Login'
import UsersScreen from './Users'
import UserInfo from './UserInfo'
import ChangePass from './ChangePassword'
import EventManagement from './EventManagement'
import ObjectScreen from './ObjectsManagement/index'
import MediaManagementScreen from './MediaManagement/index'
import RoleManagement from './RoleManagement'
import ScrumBoard from './ScrumBoard/index'
import BoardLists from './ScrumBoard/Board/BoardList/BoardList'
import CreateBoard from './ScrumBoard//Board/BoardCreateOrUpdate/BoardCreateOrUpdate'
import Board from './ScrumBoard//Board/Board'
import { Debounce } from 'react-throttle'
import WindowResizeListener from 'react-window-size-listener'

// layout
// import Footer from './shared/footer'
import TopBar from './shared/topbar'
import SideBar from './shared/sidebar'
import { Layout } from 'antd'

// language
import messages from '../services/language/messages'
import en from 'react-intl/locale-data/en'
import vi from 'react-intl/locale-data/vi'
import { IntlProvider, addLocaleData } from 'react-intl'

// auth
import Authorization from './authorization'
import appActions from '../redux/app/actions'
import ReportManagement from './ReportManagement'
import QuickMessage from './QuickMessage'
// import const
import { type } from '../constants/QBActionsConst'

addLocaleData([...en, ...vi])

// const layout
const { Content } = Layout
const { toggleAll } = appActions

// Router configuration
const UserModule = Authorization([type.USER_VIEW])
const RoleModule = Authorization([type.ONLY_SUPER_ADMIN])
const PublicModule = Authorization([type.ALL])
const OrganizationModule = Authorization([type.ORGANIZATION_VIEW])
const TaskModule = Authorization([type.TASK_VIEW])
const ObjectModule = Authorization([type.OBJECT_VIEW])
const EventModule = Authorization([type.EVENT_VIEW])
const MediaModule = Authorization([type.MEDIA_VIEW])
const ReportModule = Authorization([type.REPORT_VIEW])

const Admin = Authorization([90, 100])

class RequireLogin extends Component {
    render() {
        let { language } = this.props
        const { url } = this.props.match
        const appHeight = window.innerHeight
        console.log('url qbts', url)
        return (
            <IntlProvider locale={language} messages={messages[language]}>
                <IconContext.Provider value={{ className: 'react-icons' }}>
                    <Layout
                        id="app"
                        className="App"
                        style={{
                            flexDirection: 'row',
                            overflowX: 'hidden',
                        }}
                    >
                        <Debounce time="0" handler="onResize">
                            <WindowResizeListener
                                onResize={windowSize =>
                                    this.props.toggleAll(
                                        windowSize.windowWidth,
                                        windowSize.windowHeight
                                    )
                                }
                            />
                        </Debounce>
                        <SideBar url={url} />
                        <Layout
                            style={{
                                flexDirection: 'column',
                                width: window.innerWidth,
                                height: this.props.height,
                                backgroundPosition: 'center left',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                backgroundImage: `url(${require('../resource/image/blur-bg.jpg')}`,
                            }}
                        >
                            <TopBar
                                url={url}
                                ref={e => {
                                    this.topbar = e
                                }}
                            />
                            <Layout
                                className="isoContentMainLayout"
                                style={{
                                    background: 'none',
                                }}
                            >
                                <Content
                                    className="MainContent"
                                    style={{
                                        position: 'relative',
                                    }}
                                >
                                    <Route
                                        path={`${url}/organization-management/:id?`}
                                        component={OrganizationModule(
                                            OrganizationManagementScreen
                                        )}
                                    />
                                    <Route
                                        path={`${url}/dashboard`}
                                        component={PublicModule(HomeScreen)}
                                    />

                                    <Route
                                        path={`${url}/message/:id?`}
                                        component={PublicModule(QuickMessage)}
                                    />

                                    <Route
                                        path={`${url}/users`}
                                        component={UserModule(UsersScreen)}
                                    />

                                    <Route
                                        path={`${url}/userinfo`}
                                        component={PublicModule(UserInfo)}
                                    />
                                    <Route
                                        path={`${url}/changepass`}
                                        component={PublicModule(ChangePass)}
                                    />
                                    <Route
                                        path={`${url}/qbevents/:id?`}
                                        component={EventModule(EventManagement)}
                                    />

                                    <Route
                                        path={`${url}/qbobjects/:id?`}
                                        component={ObjectModule(ObjectScreen)}
                                    />
                                    <Route
                                        path={`${url}/qbmedias/:id?`}
                                        component={MediaModule(
                                            MediaManagementScreen
                                        )}
                                    />

                                    <Route
                                        path={`${url}/qbrole`}
                                        component={RoleModule(RoleManagement)}
                                    />
                                    <Route
                                        path={`${url}/qbreport/:id?`}
                                        component={ReportModule(
                                            ReportManagement
                                        )}
                                    />
                                    <Route
                                        exact
                                        path={`${url}/qbtask`}
                                        component={PublicModule(BoardLists)}
                                    />
                                    {/* <Route
                                        exact
                                        path={`${url}/qbtask/:id`}
                                        component={PublicModule(CreateBoard)}
                                    /> */}
                                    <Route
                                        path={`${url}/qbtask/project/:id`}
                                        component={PublicModule(Board)}
                                    />
                                    <Route
                                        component={PublicModule(ScrumBoard)}
                                    />
                                </Content>
                            </Layout>
                        </Layout>
                        {/* <Footer /> */}
                    </Layout>
                </IconContext.Provider>
            </IntlProvider>
        )
    }
}

const mapStateToProps = state => {
    return {
        language: state.language.lang,
        height: state.app.height,
    }
}

const RequireLoginContainer = connect(
    mapStateToProps,
    { toggleAll }
)(RequireLogin)

class App extends Component {
    render() {
        let { language } = this.props

        return (
            <IntlProvider locale={language} messages={messages[language]}>
                <Router history={history}>
                    <Switch>
                        <RequireLoginComponent
                            path="/app"
                            component={RequireLoginContainer}
                        />
                        <Route exact path="/login" component={LoginScreen} />
                        <Redirect to="/login" />
                    </Switch>
                </Router>
            </IntlProvider>
        )
    }
}

export default connect(
    mapStateToProps,
    null
)(App)
